"use client";
import { createContext, useContext, useEffect, useState } from "react";
import Lenis from "lenis";
import { useDocumentReady } from "@/hooks/use-document-ready";

const LenisContext = createContext<Lenis | null>(null);

export const useLenis = () => useContext(LenisContext);

export default function SmoothScroll({ children }: { children: React.ReactNode }) {
  const [lenis, setLenis] = useState<Lenis | null>(null);
  const documentReady = useDocumentReady();

  useEffect(() => {
    if (!documentReady) return;

    const lenisInstance = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
    });

    setLenis(lenisInstance);

    function raf(time: number) {
      lenisInstance.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenisInstance.destroy();
      setLenis(null);
    };
  }, [documentReady]);

  return <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>;
}
